import { Component, Input, OnInit } from '@angular/core';
import { WFComponent } from '../../../../components/workflow/workflow';
import { FormType, ReturnType } from 'src/app/common/enumerations/enumerations';

@Component({
  selector: 'cl-editor-tag-info',
  templateUrl: './cl-editor-tag-info.component.html',
  styleUrls: ['./cl-editor-tag-info.component.scss']
})
export class ClEditorTagInfoComponent implements OnInit
{
  @Input() tag?: string;
  @Input() component?: WFComponent;
  @Input() multi?: boolean;

  returnType?: string;
  returnTypes = ReturnType;

  ngOnInit(): void
  {
    this.returnType = this.returnTypes[this.component?.returnType ?? -1];
  }
}

export interface TagInfoData
{
  component: WFComponent;
  tag: string;
  conditions: string[];
  multi: boolean;
  formType: FormType
}
